import React from "react";
// React Router
import {useHistory, useParams} from "react-router-dom";
// Styled Components
import styled from "styled-components";
// Components
import VerticalCard from "../../generic/VerticalCard";

const CardMision = styled(VerticalCard)`
  background-color: #fffef5;
  :hover {
    box-shadow: 0 0px 6px #2a599f !important;
  }
`;

const MisionTarjetaAdd = ({ ...props }) => {

  let { id_p } = useParams()
  let history = useHistory();

  let provinciaId = id_p ? id_p : '14';
  let defaultImg = `/images/logoSTJ.png`;
  let img = `${process.env.REACT_APP_API_URL}/download/provincias/${provinciaId}/` ? `${process.env.REACT_APP_API_URL}/download/provincias/${provinciaId}/` : defaultImg;
  return (
      <CardMision
          onClick={(e) => {
            history.push(`mision/add`);
          }}
          cardImage={img}
          title={"Añade nueva misión"}
          imgOnError={defaultImg}
          {...props}
      />
  );
};

export default MisionTarjetaAdd;
